import { useState, useEffect } from "react";
import { Tooltip } from "@material-tailwind/react";
import { getBaseUrlWithoutApi } from "../../components/Manual_List/fetch/baseEndpoint";

interface Category {
  id: number;
  name: string;
}

interface CategoryIconsProps {
  categories: Category[];
  language: string;
  selectedCategories: string[];
  onCategorySelect: (selectedIds: string[]) => void;
}

export default function CategoryIcons({
  categories,
  language,
  selectedCategories,
  onCategorySelect,
}: CategoryIconsProps) {
  const [activeIconId, setActiveIconId] = useState<string | null>(null);

  useEffect(() => {
    setActiveIconId(
      selectedCategories.length > 0 ? selectedCategories[0] : null
    );
  }, [selectedCategories]);

  const toggleIcon = (id: string) => {
    setActiveIconId((prevId) => {
      const newActiveIconId = prevId === id ? null : id;
      onCategorySelect(newActiveIconId ? [newActiveIconId] : []);
      return newActiveIconId;
    });
  };

  return (
    <div className="w-full p-4 md:sticky top-16 z-50 bg-white dark:bg-black">
      <div className="flex flex-wrap gap-2">
        {categories.map((category) => {
          const iconSrc = `${getBaseUrlWithoutApi()}/categories/${
            category.id
          }/icon.svg`;
          const isActive = category.id.toString() === activeIconId;
          return (
            <Tooltip content={category.name} key={category.id}>
              <div
                className={`flex items-center justify-center md:size-14 size-12 rounded-lg 
                  transition-colors duration-200 cursor-pointer
                  ${
                    isActive
                      ? "bg-darkPurple/40 dark:bg-darkPurple text-white"
                      : "bg-lightPurple hover:bg-lightPink dark:bg-purple/30 dark:hover:bg-darkPurple"
                  }
                `}
                onClick={() => toggleIcon(category.id.toString())}
              >
                <img
                  src={iconSrc}
                  alt={category.name}
                  width={32}
                  height={32}
                  className={isActive ? "text-white" : "text-blue-500"}
                />
              </div>
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
}
